'use strict';



const $ = require('jquery');
const poll = require('./poll');
const $processing = $('[data-pending-cancellation]');
const getUrl = uuid => `/my-loans/cancel-loanpart-sale/${uuid}`;



if($processing.length > 0) {
	const uuid = $processing.data('pending-cancellation');
	poll(getUrl(uuid), onStatus, 2000, 6000);
}



function onStatus(res) {
	if(res.processed) {
		document.location.reload();
	}
}